export const FOOTER_LOGO_DEFAULTS = Object.freeze({
  headerText: 'Your Careers Page Footer Logo',
  subHeaderText: 'This is your Careers Page footer logo',
  logoInfo: 'This logo is used in the footer of your Careers Page. Please make sure it is a .png or .jpg file no larger than 5GB.',
})
